import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

// style
import './App.scss';

// pages
import LandingPage from './pages/LandingPage';
import AllProjects from './pages/AllProjects';

// actions
import { getProjects } from './actions/projectAction';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProjects());
    // eslint-disable-next-line
  }, []);

  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <Route path="/projects" component={AllProjects} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
